import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import colors from 'styles/colors'

interface ITabsProps {
    active: string
    tabs: string[]
    showNumber?: boolean
    tabWithNumber?: string
    number?: number
    handleOnClick?: any
}

export const Tabs = ({
    active,
    tabs,
    tabWithNumber,
    number,
    handleOnClick
}: ITabsProps) => {
    const { t } = useTranslation()

    return (
        <StyledContainer>
            {tabs.map(tab => {
                return (
                    <StyledTab
                        key={tab}
                        className={active === tab ? 'active' : 'inactive'}
                        onClick={handleOnClick}
                    >
                        {t(tab)}
                        {number && tab === tabWithNumber && (
                            <StyledNumber>{number}</StyledNumber>
                        )}
                    </StyledTab>
                )
            })}
        </StyledContainer>
    )
}

const StyledContainer = styled.div`
    padding: 0.5rem;
    height: 4rem;
    width: fit-content;
    border-radius: 2rem;
    display: flex;
    align-items: center;
    background-color: ${colors.whiteSmoke};

    @media (min-width: 680px) {
        background-color: ${colors.white};
    }
`

const StyledTab = styled.button`
    border: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 600;
    text-decoration: none;
    height: 100%;
    border-radius: 2rem;
    -webkit-tap-highlight-color: transparent;
    width: fit-content;
    padding: 0 2rem;
    position: relative;
    white-space: nowrap;
    text-overflow: ellipsis;

    &.active {
        background-color: ${colors.slateBlue};
        color: ${colors.white};
    }

    &.inactive {
        color: ${colors.grey};
    }
`
const StyledNumber = styled.span`
    background-color: ${colors.blueLighter};
    border-radius: 50%;
    color: ${colors.white};
    height: 1.6rem;
    position: absolute;
    top: -0.7rem;
    right: 0;
    width: 1.6rem;
`
